"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const action_1 = require("./action");
const core_1 = require("@actions/core");
action_1.start()
    .then(() => core_1.info('Finished!'))
    .catch(error => {
    console.log('EEE', error);
    core_1.setFailed(error.message);
});
